export default "__VITE_ASSET__BIU6XXof__"